<template>
  <div>
    <div class="item">
      <div class="left">系统直连</div>
      <div class="right">{{ listData.linkpro }}</div>
    </div>
    <div class="item">
      <div class="left">简介</div>
      <div class="right"><p v-html="listData.description"></p></div>
    </div>
    <div class="item">
      <div class="left">地址</div>
      <div class="right">{{ listData.address }}</div>
    </div>
    <div class="item">
      <div class="left">基础价格</div>
      <div class="right">{{ listData.price }}</div>
    </div>
    <div class="item">
      <div class="left">坐标</div>
      <div class="right">
        {{ listData.gis }}
      </div>
    </div>
    <div class="item">
      <div class="left">等级</div>
      <div class="right">{{ listData.level }}</div>
    </div>

    <div class="item">
      <div class="left">订单金额</div>
      <div class="right">{{ listData.number }}</div>
    </div>
    <div class="item">
      <div class="left">资金处理类型</div>
      <div class="right">{{ listData.status }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Object
    },
    listDesc: {
      type: Array
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  line-height: 45px;
  font-size: 18px;
  &:nth-child(1) {
    border-top: 1px solid #dcdfe6;
  }
  border-bottom: 1px solid #dcdfe6;
  .left {
    font-size: 15px;
    font-weight: 500;
    padding-left: 10px;
    margin-right: 10px;
    color: #909399;
    width: 200px;
    background-color: #f7f7f7;
  }
  .right {
    width: calc(100% - 210px);
    color: #303133;
  }
}
</style>
